export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: `Sito web`,
    introCreated: `Il tuo sito web è già creato. Entra a modificarlo quando vuoi.`,
    introEmpty: `Crea il sito web del tuo alloggio, con il tuo calendario incorporato. Lo modifichi trascinando, senza scrivere codice.`,
    emptyTitle: `Non hai ancora un sito web`,
    emptyBody: `Scegli un modello del settore, cambi le foto e i testi, e hai già un sito web pubblicabile. Il motore di ricerca delle date resta collegato al tuo calendario.`,
    creating: `Creazione…`,
    createCta: `Crea il mio sito web`,
    createAnother: `Creare un altro sito`,
    collapse: `Richiudere`,
    expand: `Vedere i dettagli`,
    limitReached: `Il tuo piano arriva a {n} sito/i.`,
    lockedTitle: `Il tuo sito web è incluso nel piano Suite`,
    lockedBody: `Per creare e gestire il sito web della tua struttura con WACheckin devi avere il piano Suite attivo.`,
    lockedCta: `Vedi il piano Suite`,
    nameLabel: `Nome del tuo sito web`,
    viewWeb: `Vedi il sito web`,
    opening: `Apertura…`,
    editCta: `Modifica la mia pagina`,
    noPublicAddress: `Non ha ancora un indirizzo pubblico`,
    published: `Pubblicato`,
    unpublished: `Non pubblicato`,
    visibleToPublic: `Visibile al pubblico`,
    addressTitle: `Indirizzo del tuo sito web`,
    addressSubtitle: `Scegli a quale indirizzo vuoi che lo vedano i tuoi ospiti.`,
    modeWacheckin: `Usa un indirizzo WACheckin`,
    modeWacheckinHint: `Gratis e pronto subito`,
    modeOwn: `Usa il tuo dominio`,
    modeOwnHint: `Se ne hai già uno`,
    subdomainLabel: `La parola che va davanti`,
    subdomainPlaceholder: `nome-del-tuo-alloggio`,
    saving: `Salvataggio…`,
    save: `Salva`,
    subdomainPreview: `Il tuo sito web sarà su`,
    subdomainFree: `Scrivilo come vuoi: lo trasformiamo in un indirizzo valido.`,
    otherDomainNote: `Hai anche {dominio} collegato. Questo indirizzo continuerà a funzionare e porterà allo stesso sito web.`,
    noDomainYet: `Non hai ancora detto quale dominio vuoi`,
    continueConnection: `Continua la connessione`,
    connectDomain: `Collega il mio dominio`,
    searchTitle: `Quali alloggi può consultare il motore di ricerca`,
    searchSubtitle: `Quelli che selezioni qui sono quelli che vedranno i tuoi ospiti quando cercano le date.`,
    missingPhotosLabel: `Ancora senza foto:`,
    missingPhotosHelp: `Caricale in Prenotazioni dirette → Immagini e appariranno qui. Non è necessario che siano in vendita.`,
    previewError: "Impossibile caricare l'anteprima.",
    previewRetry: "Riprova",
    deleteExplain: "Elimina il sito e tutto quello che contiene. Non si può annullare.",
    deleteTitle: "Eliminare «{nombre}»?",
    deleteBody: "Non si può annullare. Se vuoi solo nasconderlo, spegni «Visibile al pubblico» e il sito resta salvato.",
    deleteItemPages: "Le sue {n} pagine, con testi e design",
    deleteItemAddress: "L'indirizzo su cui si vede adesso",
    deleteItemMessages: "I messaggi arrivati dai suoi moduli",
    deleteCancel: "Annulla",
    deleteConfirm: "Sì, elimina",
    deleting: "Eliminazione…",
    previewTitle: "Il tuo sito adesso",
    previewDesktop: "Computer",
    previewMobile: "Cellulare",
    previewLoading: "Caricamento del sito…",
    previewNote: "Così si vede con le ultime modifiche salvate. I tuoi ospiti vedono l'ultima versione pubblicata.",
    footerNote: `Per ora ogni account ha un sito web. Scrivici se ne hai bisogno di più.`,
    deleteWeb: `Elimina questo sito web`,
    mensajes: {
      title: "Messaggi del tuo sito",
      subtitle: "Quello che ti scrivono nei moduli del tuo sito. Ogni messaggio ti arriva anche per e-mail.",
      inbox: "In arrivo",
      archived: "Archiviati",
      unread: "{n} da leggere",
      empty: "Nessuno ti ha ancora scritto. Quando qualcuno compilerà un modulo del tuo sito lo vedrai qui e ti arriverà per e-mail.",
      emptyArchived: "Non hai messaggi archiviati.",
      loadError: "Non è stato possibile caricare i messaggi.",
      retry: "Riprova",
      reply: "Rispondi per e-mail",
      whatsapp: "WhatsApp",
      call: "Chiama",
      markRead: "Segna come letto",
      markUnread: "Segna come da leggere",
      archive: "Archivia",
      unarchive: "Riporta in arrivo",
      delete: "Elimina",
      confirmDelete: "Eliminare questo messaggio? Non si può annullare.",
      confirmYes: "Sì, elimina",
      confirmNo: "No",
      form: "Modulo",
      from: "Da",
      more: "Mostra altri",
      anonymous: "Senza nome",
      replySubject: "Il tuo messaggio su {sitio}",
      notSent: "L'avviso per e-mail non è ancora partito.",
      errorAction: "Non è stato possibile salvare la modifica. Riprova.",
    },
    loadingAccommodations: `Caricamento dei tuoi alloggi…`,
    noPhotosYet: `Nessuno dei tuoi alloggi ha ancora foto. Caricale in Prenotazioni dirette → Immagini e potrai mostrarli qui.`,
    noAccommodations: `Non hai ancora creato alloggi.`,
    loadError: `Impossibile caricare le tue pagine.`,
    defaultSiteName: `Il mio alloggio`,
    createError: `Impossibile creare la pagina.`,
    saveError: `Impossibile salvare.`,
    subdomainTooLong: `È diventato troppo lungo.`,
    subdomainReserved: `Questa parola è riservata. Provane un'altra.`,
    addressSaved: `Indirizzo salvato.`,
    subdomainChecking: `Verifica della disponibilità…`,
    subdomainAvailable: `È libero. Il tuo sito web sarà su`,
    subdomainChangeWarning: `Una volta salvato, l'indirizzo attuale smetterà di funzionare.`,
    subdomainTaken: `Un altro sito web usa già questo indirizzo.`,
    subdomainTryThis: `Questo è libero:`,
    subdomainUse: `Usa questo`,
    subdomainGeneric: `Non dice nulla del tuo alloggio. Ti proponiamo:`,
    subdomainProposal: `Te ne proponiamo uno con il nome del tuo alloggio:`,
    domainHelpEmpty: `Ti guidiamo passo dopo passo: scrivi il dominio, copi due righe nel pannello dove l'hai acquistato e lo verifichiamo noi.`,
    domainHelpPending: `Mancano i record nel pannello del tuo dominio, oppure non sono ancora arrivati ovunque. Entra e lo verifichiamo.`,
    popupBlocked: `Consenti le finestre pop-up per aprire l'editor.`,
    editorError: `Impossibile aprire l'editor.`,
    confirmDelete: `Eliminare « {nombre} »? Il sito web non sarà più visibile.`,
    deleteError: `Impossibile eliminare.`,
  },

  selectOta: {
    lockBadge: `Funzione in abbonamento`,
    lockTitle: `Collega le tue OTA con un piano attivo`,
    lockText: `Per sincronizzare <b>Booking, Airbnb, Vrbo, Expedia</b> e altri canali con WA&nbsp;Checkin devi avere un abbonamento a un piano. Con il tuo abbonamento, Janet sincronizza prezzi, disponibilità e prenotazioni automaticamente — senza overbooking e senza attività manuali.`,
    morePreviewTitle: `e più di 100 OTA`,
    otasAvailable: `OTA disponibili`,
    lockCta: `Vedi i piani e abbonati`,
    lockFoot: `Sincronizzazione automatica · Anti-overbooking · Supporto alla connessione incluso`,
    connectOtaTitle: `Collega OTA`,
    googleFaltan: "Alla tua scheda manca 1 cosa per Google | Alla tua scheda mancano {count} cose per Google",
    googlePreparar: "Preparala",
    beta: `Beta`,
    pctChipTitle: `Percentuale di tariffa derivata per questa OTA`,
    comingSoon: `Prossimamente`,
    manage: `Gestisci`,
    connectNow: `Collega ora`,
    pctModalTitle: `Percentuale di tariffa`,
    pctModalHint: `Quale percentuale in più (o in meno) farai pagare ai tuoi ospiti se prenotano tramite <b>{ota}</b>? Usa <b>+</b> per far pagare di più o <b>−</b> per far pagare di meno (es.: <b>15.5</b> o <b>−10</b>).`,
    thisOta: `questa OTA`,
    cancel: `Annulla`,
    saving: `Salvataggio…`,
    save: `Salva`,
    exploreMore: `Esplora più di 100 OTA disponibili`,
    activeConnections: `Connessioni attive`,
    searchPlaceholder: `Cerca...`,
    loadingConnections: `Caricamento connessioni...`,
    thChannel: `CANALE`,
    thConnectionId: `ID CONNESSIONE`,
    thLastSync: `ULTIMA SINCRONIZZAZIONE`,
    thActions: `AZIONI`,
    copied: `Copiato!`,
    copyId: `Copia ID`,
    contactTitle: `Collegati con {name}`,
    contactDescription: `Collega facilmente il tuo account {name} alla nostra piattaforma per velocizzare la tua esperienza. Segui i passaggi qui sotto per completare il processo.`,
    step1Title: `Crea un account {name}`,
    step1Description: `Se non hai ancora un account {name}, dovrai prima crearne uno.`,
    createAccountLink: `Crea account →`,
    step1Hint: `Hai già un account? Vai al passaggio 2.`,
    step2Title: `Contatta il team di assistenza`,
    step2Description: `Una volta pronto il tuo account {name}, il nostro team ti aiuterà a collegarlo.`,
    contactSupportLink: `Contatta il team di assistenza →`,
    connectDirectNoSupport: `Collega direttamente (senza assistenza) →`,
    step2Hint: `Consigliato solo se sai cosa configurare in Channex.`,
    connectDirectly: `Collega direttamente`,
    iframeTitle: `Collega con {channel}`,
    iframeSubtitle: `Connessione sicura gestita dal channel manager`,
    close: `Chiudi`,
    iframeLoading: `Apertura della connessione sicura…`,
    actionRequired: `Azione richiesta`,
    viewPlans: `Vedi i piani`,
    descBooking: `Raggiungi viaggiatori d'affari e di piacere in tutto il mondo`,
    descAirbnb: `Collega la tua struttura con milioni di viaggiatori su Airbnb`,
    descVrbo: `Specializzato in case vacanza per famiglie`,
    descExpedia: `Rete di viaggi globale con milioni di utenti attivi`,
    descBnb: `Portale italiano di B&B e alloggi di charme`,
    descGvr: `Compari gratis nei risultati di Google Maps e nelle ricerche`,
    descAgoda: `Raggiungi viaggiatori dall'Asia e dal resto del mondo`,
    descHotelbeds: "Letti per agenzie e tour operator di tutto il mondo",
    savePercentError: `Impossibile salvare la percentuale. Riprova.`,
    channelGeneric: `Canale`,
    statusInactive: `Inattivo`,
    statusConnected: `Connesso`,
    statusSyncing: `Sincronizzazione`,
    webReservationsName: `Prenotazioni dirette via web`,
  },

  connectionChannel: {
    errorTitle: `Errore`,
    successTitle: `Successo`,
    connectionDisabled: `La connessione è disattivata`,
    syncError: `Errore durante la sincronizzazione`,
    loadPropertiesError: `Errore nel caricamento delle proprietà`,
    connectionUpdated: `Connessione aggiornata {channelName}`,
    updateConnError: `Errore nell'aggiornamento della connessione: {detail}`,
    unknownError: `Errore sconosciuto`,
    connectionWith: `Connessione con {channelName} {status}`,
    stateUpdatedTitle: `Stato aggiornato`,
    confirmDeleteMessage: `Sei sicuro di voler eliminare questa connessione? Verranno eliminate anche le proprietà e le prenotazioni associate.`,
    confirmDeleteHeader: `Conferma eliminazione`,
    deleteConnection: `Elimina connessione`,
    no: `No`,
    connectionDeleted: `Connessione eliminata con successo`,
    deleteConnError: `Errore nell'eliminazione della connessione: {detail}`,
    webhookCopied: `Webhook copiato negli appunti`,
    webhookCopyError: `Errore nel copiare il webhook`,
    title: `Canale di connessione (PMS)`,
    description: `In questa sezione potrai collegarti con sistemi di gestione immobiliare (PMS) per effettuare consultazioni, gestione e aggiornamento delle informazioni in modo efficiente e senza errori.`,
    connectedAccount: `Account collegato`,
    switchTooltip: `Ferma o attiva il servizio che riceve automaticamente le prenotazioni nel sistema.`,
    syncing: `Sincronizzazione...`,
    sync: `Sincronizza`,
    deleting: `Eliminazione...`,
    webhookLabel: `WEBHOOK:`,
    webhookInfoTooltip: `Aggiungi questo Webhook al tuo account Smoobu per ricevere automaticamente le prenotazioni create nel tuo PMS`,
    copyToClipboard: `Copia negli appunti`,
    syncedProperties: `Proprietà sincronizzate`,
    noAddress: `Senza indirizzo`,
    noSyncedProperties: `Non ci sono proprietà sincronizzate`,
  },

  wabaIntegration: {
    activationInProgress: `Attivazione in corso`,
    pendingBody: `Stiamo attivando il WhatsApp della tua azienda. Mentre Meta approva i tuoi modelli (di solito richiede fino a 24&nbsp;h) e verifica il tuo numero, i tuoi messaggi vengono inviati con il <strong>WhatsApp di WACheckin</strong> in modo che tu non smetta di comunicare con i tuoi ospiti. Passerà al tuo numero <strong>automaticamente</strong> non appena sarà pronto — non devi fare nulla.`,
    phoneStatusHeading: `Stato del numero WhatsApp`,
    numberLabel: `Numero:`,
    virtualNumberNote: `Questo è un <strong>numero virtuale fornito da Meta</strong>. Non riceve chiamate né SMS normali, solo messaggi WhatsApp tramite l'API.`,
    statusLabel: `Stato:`,
    templatesStatusHeading: `Stato dei modelli`,
    canSend: `Il tuo numero è <strong>connesso e verificato</strong> e hai almeno un modello approvato. Ora puoi inviare messaggi.`,
    cannotSendYet: `Ancora <strong>non puoi inviare messaggi</strong>. Attendi che Meta approvi il numero di telefono e i modelli.`,
    virtualPendingNote: `Tieni presente che, se la tua azienda su Meta non è verificata, i numeri virtuali possono rimanere nello stato <strong>in attesa</strong> e non consentire l'invio.`,
    statusConnectedVerified: `Connesso e verificato`,
    statusConnectedPending: `Connesso, in attesa di verifica`,
    statusPendingApproval: `In attesa di approvazione`,
    statusDisconnected: `Disconnesso`,
    statusUnknown: `Sconosciuto`,
  },
};
